import { renderRoot } from 'quartz-core/client';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';

// I18n Configuration
import createAllI18nProvider from 'I18n/init/providers/createAllI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { LocaleProvider } from './components/locales/LocaleProvider';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Configure the router
import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import { Routes } from './components/Routes';

// Apollo
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class App {
  // Kicks off the app. This is intentionally not in the constructor.
  async start() {
    /*
     * This should render based on the browser locale. Need to use the ALL provider instead of
     * public so locales are loaded and can be changed by our language select.
     * Doc: https://product.hubteam.com/docs/frontend/docs/i18n/new-i18n-setup.html#alli18nprovider
     * Relevant slack thread: https://hubspot.slack.com/archives/C4ABAB8CR/p1683049769060419
     */
    const I18nAllProvider = createAllI18nProvider({
      shouldSetPublicI18n: true
    });
    const langAvailable = initAppTranslations([I18nAllProvider.register(lang), registerAllData(I18nAllProvider)]);
    await langAvailable;
    setDocumentTitle('app.htmlTitle');
    this.startRouter();
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    const dataFetchingClient = new DataFetchingClient();
    renderRoot( /*#__PURE__*/_jsxs(UIApplication, {
      name: "data-privacy-request-ui",
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: dataFetchingClient,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(LocaleProvider, {
              children: /*#__PURE__*/_jsx(Routes, {})
            })
          })
        })
      })]
    }));
  }
}